﻿import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CheckCircle } from "lucide-react";

import Fetching from "@/components/Fetching/Fetching";

import { getDashboardOut } from "@/api/Dashboard/dashboard";
import { dateToLocale, initialText } from "@/services/Utils";

import classes from "./dashboard-out.module.scss";

const DashboardOut = ({ filters }) => {
	const navigate = useNavigate();

	const { estate_parent_id, estate_id, type_currency } = useSelector((state) => state.auth.filter);

	const { data, isLoading } = useQuery(["dashboard_out", { ...filters, estate_parent_id, estate_id, type_currency }], () =>
		getDashboardOut({ ...filters, estate_parent_id, estate_id, type_currency }),
	);

	return (
		<>
			{isLoading ? (
				<Fetching topMargin="5em" bottomMargin="5em" />
			) : (
				<>
					<div className={classes.style_table}>
						<table className={classes.style_table_title}>
							<thead>
								<tr>
									<th className={classes.table_th} style={{ width: "20%" }}>
										Cód.
									</th>
									<th className={classes.table_th} style={{ width: "30%" }}>
										Nombre
									</th>
									<th className={classes.table_th} style={{ width: "20%" }}>
										Fecha
									</th>
									<th className={classes.table_th} style={{ width: "30%" }}>
										Operador
									</th>
								</tr>
							</thead>
						</table>
						{data.length === 0 ? (
							<div className={classes.no_products}>
								<CheckCircle size={48} color="#82bc44" />
								<span>Todo en orden, no hay productos fuera de bodega</span>
							</div>
						) : (
							data.map((item, i) => {
								return (
									<table key={i} className={classes.style_table_body}>
										<tbody>
											<tr>
												<td style={{ width: "20%" }}>{item.inventory_id}</td>
												<td style={{ width: "30%" }}>{item.product}</td>
												<td style={{ width: "20%" }}>{dateToLocale(item.date_weight)}</td>
												<td style={{ width: "30%" }}>{initialText(item.operator)}</td>
											</tr>
										</tbody>
									</table>
								);
							})
						)}
					</div>

					{data.length > 0 && (
						<div className={classes.footer}>
							<div className={classes.footer_text} onClick={() => navigate("/historiales/en_uso")}>
								Ver más...
							</div>
						</div>
					)}
				</>
			)}
		</>
	);
};

export default DashboardOut;
